import classes from "./ParkingTokenItem.module.css";

const ParkingTokenItem = (props) => {
  return <span className={classes.token}>{props.token}</span>;
};

export default ParkingTokenItem;